import { render, staticRenderFns } from "./DependentStudyVisa.vue?vue&type=template&id=16e671fb&"
import script from "./DependentStudyVisa.vue?vue&type=script&lang=js&"
export * from "./DependentStudyVisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports